module.exports = __webpack_public_path__ + "static/26-353c1bd99700bedbb2acf1fae9b487e7.png";